import { Carrier } from '@insurgrid/common';
import classNames from 'classnames';
import { BiCheck } from '@react-icons/all-files/bi/BiCheck';
import { ReactNode } from 'react';
import { Testable } from './types';
import { CarrierIcon } from './CarrierIcon';

export enum CarrierStatus {
  Validated = 'validated',
}

interface CarrierDisplayProps {
  carrier: Pick<Carrier, 'logo' | 'slug' | 'name' | 'websiteUrl'>;
  className?: string;
  iconClassName?: string;
  hideIcon?: boolean;
  status?: CarrierStatus;
  showWebsite?: boolean;
  maxWidth?: boolean;
  customCarrierIcon?: ReactNode;
}

const carrierStatus: Record<CarrierStatus, ReactNode> = {
  [CarrierStatus.Validated]: (
    <div className="bg-green-500 w-5 h-5 rounded-full flex items-center justify-center">
      <BiCheck className="text-white" size={18} />
    </div>
  ),
};

export function CarrierDisplay({
  showWebsite = true,
  maxWidth = false,
  ...props
}: Testable<CarrierDisplayProps>) {
  return (
    <div
      data-test-id={props['data-test-id']}
      className={classNames(
        'flex justify-between text-sm text-left max-w-full',
        props.className,
      )}
    >
      <div className={classNames('flex', !maxWidth && 'w-full')}>
        {!props.hideIcon && (
          <CarrierIcon
            src={props.carrier.logo}
            slug={props.carrier.slug}
            className={props.iconClassName}
            customImage={props.customCarrierIcon}
          />
        )}
        <div
          className={classNames(
            'flex flex-col justify-center overflow-hidden',
            !props.hideIcon && 'ml-3',
            maxWidth && 'w-min max-w-[12rem] whitespace-nowrap',
          )}
        >
          <p className="truncate">{props.carrier.name}</p>
          {showWebsite && (
            <p className="text-gray-400 text-xs truncate max-w-[12rem]">
              {props.carrier.websiteUrl.replace(/http(s?):\/\//, '')}
            </p>
          )}
        </div>
      </div>
      {props.status && carrierStatus[props.status]}
    </div>
  );
}
